// Copyright (C) 2020-2025 Skylark Drones

import BaseApi from './baseHttpApi'
import { BASE_EVENT_GATEWAY_HOST_URL } from '@/constants'

export default class v4Api extends BaseApi {
  whitelistURLs = []

  constructor() {
    super('api/v1', BASE_EVENT_GATEWAY_HOST_URL)
  }
}
